import { render } from "./SuggestedCategories.vue?vue&type=template&id=2ac0bbbd&ts=true"
import script from "./SuggestedCategories.vue?vue&type=script&lang=ts"
export * from "./SuggestedCategories.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/product-category-selector/tabs/SuggestedCategories.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ac0bbbd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ac0bbbd', __exports__)) {
    api.reload('2ac0bbbd', __exports__)
  }
  
  module.hot.accept("./SuggestedCategories.vue?vue&type=template&id=2ac0bbbd&ts=true", () => {
    api.rerender('2ac0bbbd', render)
  })

}


export default __exports__